import noop from 'utils/noop';
import { InputText } from 'ui/inputs';
import { HelpToggletip, TipPlacement } from 'ui/tooltip';

import {
  FormBodyText,
  SmallInputWrapper,
  RowWrapper,
} from 'modules/workflowNodeEditors/EditorBody.styled';

export interface EntranceLimitInputProps {
  /** The description of the entrance limit */
  description?: string;
  /** The id of the input container */
  inputId?: string;
  /** The input placeholder */
  placeholder?: string;
  /** Text shown at the end of the input (EG: "entry") */
  suffix?: string;
  /** Text shown at the end of the input if it requires a plural (EG: "entries") */
  suffixPlural?: string;
  /** Informational text shown in the toggle tip */
  toggletipText?: string;
  /** The limit */
  value: number | null;
  /** Callback triggered when the limit is changed */
  onChange?: (value: number | null) => void;
  /** whether or not the input has an error */
  hasError?: boolean;
  /** unique id used for locating the input from a test */
  testId?: string;
  isDisabled?: boolean;
}

export const EntranceLimitInput = ({
  description = '',
  inputId,
  placeholder = '',
  suffix = '',
  suffixPlural = '',
  toggletipText = '',
  hasError = false,
  value,
  testId,
  isDisabled,
  // callbacks
  onChange = noop,
}: EntranceLimitInputProps) => {
  const handleChange = (nextValue: string) => onChange(parseInt(nextValue, 10) || null);

  return (
    <RowWrapper data-test={testId}>
      <SmallInputWrapper>
        <InputText
          id={inputId}
          onChange={handleChange}
          placeholder={value ? '' : placeholder}
          Suffix={<div>{Number(value) === 1 ? suffix : suffixPlural}</div>}
          type="number"
          value={value?.toString() || ''}
          hasError={hasError}
          isDisabled={isDisabled}
        />
      </SmallInputWrapper>
      {description && <FormBodyText>{description}</FormBodyText>}
      {toggletipText && (
        <HelpToggletip placement={TipPlacement.Bottom} tooltipContent={toggletipText} />
      )}
    </RowWrapper>
  );
};

export default EntranceLimitInput;
